import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
export var UndroppableMessage = function () {
    var t = useTranslation().t;
    return (React.createElement(Text, { "data-testid": "undroppable-header-message" }, t('shift_management_features_DropShiftModal_UndroppableMessage_submitATimeOffRequestToDrop')));
};
